import {
  findPromoMatch,
  resolvePromoDisplay,
  type EcommercePromoCode,
} from "./findPromoMatch"

export type PriceListEntry = {
  currency: string
  crossedOutPrice: string
  discount?: string | null
  discountCode?: string | null
}

const formatPriceAmount = (amount: number, currencyCode: string): string => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
  }).format(amount)
}

export function buildPriceListEntry(
  priceResponse: any,
  currencyCode: string,
  promoCodesFromDatastorage?: EcommercePromoCode[],
): PriceListEntry | null {
  if (!priceResponse || priceResponse?.errorCode) return null

  const basePrice = priceResponse?.amount
  const promosFromAPI = priceResponse?.marketingPromos
  const hasMarketingPromo = promosFromAPI?.length > 0

  const { selectedPromoFromAPI } = findPromoMatch(
    promosFromAPI,
    promoCodesFromDatastorage,
  )
  const salePrice = selectedPromoFromAPI?.amount
  const { discount, discountCode } = resolvePromoDisplay(
    promosFromAPI,
    promoCodesFromDatastorage,
  )

  if (hasMarketingPromo && salePrice != null) {
    return {
      currency: formatPriceAmount(salePrice, currencyCode),
      crossedOutPrice:
        basePrice != null ? formatPriceAmount(basePrice, currencyCode) : "",
      discount,
      discountCode,
    }
  }

  if (basePrice != null) {
    return {
      currency: formatPriceAmount(basePrice, currencyCode),
      crossedOutPrice: "",
      discount: null,
      discountCode: null,
    }
  }

  return null
}
